'use client';
import { useEffect } from 'react';
import CartButton from '@/features/home/Flash_sales/components/CartButton';
import NextImage from '@/features/Image';
import { sliceRoute } from '@/utils/sliceRoute';
import { pushToDataLayer, toGa4Item } from '@/features/gtm/gtmUtils';
import Link from 'next/link';
import { FaStar } from 'react-icons/fa6';

const ProductListingCard = ({
  title,
  products,
  categoryUrl,
}: {
  title: string;
  products: any;
  categoryUrl: string;
}) => {
  const itemListId = categoryUrl || title.toLowerCase().replace(/\s+/g, '_');

  useEffect(() => {
    if (!products?.length) return;

    pushToDataLayer('view_item_list', {
      ecommerce: {
        item_list_id: itemListId,
        item_list_name: title,
        items: products.map((product: any, index: number) =>
          toGa4Item(product, index + 1)
        ),
      },
    });
  }, [products, itemListId, title]);

  const handleProductSelect = (product: any, index: number) => {
    pushToDataLayer('select_item', {
      ecommerce: {
        item_list_id: itemListId,
        item_list_name: title,
        items: [toGa4Item(product, index + 1)],
      },
    });
  };

  return (
    <div className="row g-3">
      <div className="col-12">
        <div className="product-listing__title">
          <h3 className="fw-medium">{title}</h3>
        </div>
      </div>
      {products.map((product: any, i: number) => (
        <div className="col-12" key={i}>
          <div className="product__item product__item--style3">
            <div className=" product__item-inner">
              {product.badge && (
                <div className="product__item-badge">{product.badge}</div>
              )}
              <Link
                href={`/product/${product.slug}`}
                className="product__item-thumb"
                style={{ maxWidth: '128px' }}
                onClick={() => handleProductSelect(product, i)}
              >
                <NextImage
                  width={116}
                  height={116}
                  src={product?.pictures?.[0]?.url}
                  alt={product.title || 'Product Image'}
                  className="w-auto"
                />
              </Link>
              <div className="product__item-content">
                <h5 className="fw-semibold">
                  <Link
                    href={`/product/${product?.slug}`}
                    onClick={() => handleProductSelect(product, i)}
                  >
                    {product?.name || product.title}
                  </Link>
                </h5>
                <div className="product__item-rating">
                  <FaStar /> {product?.ratings || product.rating}{' '}
                  <span>({product?.reviews})</span>
                </div>
                <div className="product__item-footer">
                  <div className="product__item-price">
                    <h6 className="fs-sm fw-medium mb-0">
                      ৳
                      {Number(product?.sale_price || product?.price).toFixed(0)}
                    </h6>

                    {product?.sale_price < product?.price && (
                      <span className="fs-sm">
                        / <del>৳{product?.price}</del>
                      </span>
                    )}
                  </div>
                  <div className="product__item-action">
                    <CartButton product={product} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="col-12">
        <div className="product-listing__more text-center">
          <Link
            href={`${categoryUrl && sliceRoute(categoryUrl)}`}
            className="trk-btn trk-btn--outline mt-3"
          >
            View All Products
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductListingCard;
